import { Component, ElementRef,HostListener, Input, OnDestroy, OnInit, AfterViewInit, ViewChild, ViewEncapsulation } from '@angular/core';
import {Subject, Observable} from "rxjs";
import { sampleTime, map, throttleTime } from 'rxjs/operators';
import {PaymentDonateModalComponent}  from '../payment-donate-modal/payment-donate-modal.component';
   import {StatService}  from "../../services/stat.service";
//import * as Clappr from 'clappr'

import {getQualitySelector} from './plugins/quality-selector.js'
import {bindSubtitle} from './plugins/subtitles.js'
import {getLiveViewersPlugin} from './plugins/live-viewers.js'
import {getDonatePlugin} from './plugins/donate.js'
import {  NbDialogService  } from '@nebular/theme';
//import {getPip} from './plugins/pip.js' 
declare var Clappr
declare var ClapprPip
declare var AudioTrackSelector
//declare var DashShakaPlayback
//declare var ClapprStats
declare var ClapprSubtitle 

@Component({
  selector: 'watch-video-player',
  templateUrl: './watch-video-player.component.html',
  styleUrls: [
    './watch-video-player.component.scss'
  ],
  encapsulation: ViewEncapsulation.None,
})
export class WatchVideoPlayerComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('target', {static: true}) target: ElementRef;
 

  @Input() sources: {src:string, type}[];
  @Input() coverImage:  string ;
  @Input() embeded:  boolean;
  @Input() socket:  any;
  @Input() stream:  any;
  @Input() autoplay:  boolean = true;

  viewersNow:number = 0
 
   hideSeek: boolean = false
   isFullscreen: boolean = false

  liveViewersPlugin: any
  donatePlugin: any
 // public embed:boolean = false;
  src:string;
  sessionKey:string="";
  sessionUnique: boolean  = false;
  player: any ;
  covered: boolean  = true;
  transformedX: boolean  = false;
  videoElement: any = null;
    initialStatSent: boolean  = false;
    

    statTimer = null
    watchTime = -1
    watchTimeTemp = -1
    watchSubTime = -1
    updateStat = false
     contentType:string = ''
     
  // tempInc = 0
  crsrc:any = '';
   
   watchTimeObserver:any
   watchTime$: any


  constructor(
    private elementRef: ElementRef,
 private statService: StatService,
     private dialogService: NbDialogService
  ) { 

	 
    //console.log(PIPPlugin)   
  }


 @HostListener('window:beforeunload', ['$event'])  onBeforeUplod($event) {
   this.statUpdate()
  }

  ngOnInit() {


	
		//this.embed = this.embeded
     	    this.sessionKey = this.stream.session.local_session_id
     	    this.sessionUnique = this.stream.session.unique

	    this.socket.on('changeWatchers', this.viewersChanged.bind(this))
	    this.socket.on('donateStateChanged', this.donateStateChanged.bind(this))

	    	    this.socket.on('showWatchersToggle', this.showWatchersToggle.bind(this))


	  	 this.watchTimeObserver = new Subject()
		this.watchTime$ = this.watchTimeObserver.pipe(sampleTime(1000)).subscribe((e)=>{this.onWatchTimeUpdate(e)})


		
		this.statTimer = setInterval(()=>{this.statUpdate() },30000)
	 
	}  

   statUpdate(){
		
		if(this.updateStat){


                     /*
			if(this.contentType !== 'live'){
			 let contentType = this.player.core.getCurrentContainer().playback.getPlaybackType()
				if(contentType !== this.contentType && contentType === 'live'){
			   	this.initialStatEvent(this.contentType)
				}
			}
			*/
  
			this.updateStat = false

			let time = this.watchSubTime;
			this.watchSubTime = 0

 
			//this.socket.emit('watchPaystat',time)

			
		       this.timeEvent(this.watchTime)
			

		}


   }

/**/

   onWatchTimeUpdate(e){


	let watchTimeTemp = e.current.toFixed(0)

	

	if(this.watchTimeTemp !== watchTimeTemp){
		this.updateStat = true
		this.watchTime++
		this.watchSubTime++
		this.watchTimeTemp = watchTimeTemp

	} 
 
	

   }



  streamStarted(){
		
	if(this.stream.viewersInWatch && this.stream.isRunning){

			this.liveViewersPlugin.setShowLive(true)
	}

  }


  streamStoped(){

	this.liveViewersPlugin.setShowLive(false)
  }


  viewersChanged(viewers){
		
	this.viewersNow = viewers
	this.liveViewersPlugin.setActualNum(viewers)
  }
 
  donateStateChanged(state){
	  this.donatePlugin.setDonates(state); 
  }

  showWatchersToggle({show, viewers}){
	this.stream.viewersInWatch = show
       this.viewersNow = viewers
	this.liveViewersPlugin.setActualNum(viewers)
	this.liveViewersPlugin.setShowLive(show)
      
	

  }


  toggleTransform(){
	if(this.videoElement){
		if(this.transformedX){
			this.videoElement.style['transform'] = ''
		    this.transformedX = false
		}else{

		     this.videoElement.style['transform'] = 'scaleX(-1)'
		    this.transformedX = true
		}

	}

  }

  setSource(source){
    this.src =  source.src
	this.covered = false;
    //this.target.nativeElement.src = source.src
     this.player.load( source.src)
	 
 
  }


  play(){
      this.player.play()
  }
 
 


  initialStatEvent(playbackType){
  
        if(playbackType === 'live'){

		this.hideSeek = this.stream.disableSeekLine
	}
	if(this.sessionKey && this.socket){
		this.socket.emit('stat',{type:'type', id: this.stream._id, isUnique: this.sessionUnique, session: this.sessionKey, payload: playbackType})
	}
 

  }


  timeEvent(time){
	//&& this.socket
	 if(this.sessionKey ){
		 this.socket.emit('stat',{type:'time', id: this.stream._id, isUnique: this.sessionUnique,  session: this.sessionKey, payload: time})

		// console.log(time)
	  }
	
  }


 ngAfterViewInit(){ 
 

   const QualitySelector = getQualitySelector(Clappr)
   const LiveViewers = getLiveViewersPlugin(Clappr)
   const DonatePlugin = getDonatePlugin(Clappr)
 
 
 
 
 const subtitlesPlugin = bindSubtitle(Clappr)
 
 let subtitleItems = [];
  if(this.stream.enabledSubtitles){
 
  
     for(let item of this.stream.subtitles){
     
         if(item.title && item.file){
         	subtitleItems.push(
         	item
         	)
         }
     	
     }
  
  /*  [
        	{title: "ua", file: "uploads/srts/c.srt"},
        	{title: "en", file: "uploads/srts/c2.srt"},
        
        ] */ 
 
  
  }
 
 
 //
  this.player = new Clappr.Player({src:this.src,
    plugins:[ /* ClapprStats,*/ QualitySelector, ClapprPip.PipButton, ClapprPip.PipPlugin, AudioTrackSelector , LiveViewers, DonatePlugin, subtitlesPlugin   ],
 
 subtitle : {
        src : null,
        auto : false, 
        
        subtitlesList: subtitleItems
        // automatically loads subtitle
      /*    backgroundColor : 'transparent',
        fontWeight : 'normal',
        fontSize : '14px',
        color: 'yellow',
        textShadow : '1px 1px #000'   */ 
    },

  strings: {
            'ua-UA': {
                'live': 'LIVE',
                'back_to_live': 'Back to live',
            }
        }, /**/
               language: 'ua-UA',

 	height: '100%',
        width: '100%',
	// autoPlay:true,
	autoPlay: this.autoplay,
 disableErrorScreen: true,
 
	poster: this.coverImage,
	/* clapprStats: {
	 runEach: 30000,
 
		onReport: (metrics) => {
			
			let w = Math.round((Math.round(metrics.timers.watch) / 1000))
                        this.timeEvent(w)
            
			 

		},

	}, */

	events: {
	

	onTimeUpdate: (e)=>{
		//console.log()
		if(this.player.isPlaying())
	 	this.watchTimeObserver.next(e)
	}, /**/



	onReady:()=>{ 
  
 
  	 var video = this.target.nativeElement.querySelectorAll('video')[0];
	   if(video){
	this.videoElement = video
	video.setAttribute('webkit-playsinline','true');
	video.setAttribute('playsinline','true');
	 
}
  	 
	 }, onEnded:()=>{ },	onPlay:(e)=>{

		
		if(!this.initialStatSent){ 
		   this.initialStatSent = true; 	
                   this.contentType = 	this.player.core.getCurrentContainer().playback.getPlaybackType()
		   this.initialStatEvent(this.contentType)
		}

	}


		}
  });      
  
  
/*  
    setTimeout(()=>{
    
    console.log(this.player.getPlugin("subtitlesPlugin") ) 
    let pl = this.player.getPlugin("subtitlesPlugin")
    
   pl.setAnotherSource("uploads/srts/c2.srt")
  
    
       setTimeout(()=>{
    
    console.log(this.player.getPlugin("subtitlesPlugin") ) 
    let pl = this.player.getPlugin("subtitlesPlugin")
   pl.setAnotherSource("uploads/srts/c2.srt")
      
    //pl.onContainerChanged()
    
    
    },20000)
    
    },20000)
      
 */

	 this.player.on(Clappr.Events.PLAYER_FULLSCREEN, (isFullscreen)=> { 
	 this.isFullscreen = isFullscreen
	});

  //playsinline   
 

  this.player.attachTo(this.target.nativeElement) 
  //console.log(this.target.nativeElement)

	this.liveViewersPlugin = this.player.getPlugin('live_viewers')


	if(this.stream.viewersInWatch && this.stream.isRunning){

			this.liveViewersPlugin.setShowLive(true)
	}


    this.donatePlugin = this.player.getPlugin('donate_plugin')


	if(this.stream.donateMode){ this.donatePlugin.setDonates(true);  }

	this.donatePlugin.setClickCb(this.onDonateClick.bind(this)) 
}


  onDonateClick(){
	//alert('click')

    

		if(this.isFullscreen){this.player.core.mediaControl.toggleFullscreen()}
	   if(this.stream.publicIdentity === '88a45f5a'){
		 window.open('https://www.paypal.com/donate/?hosted_button_id=QNBZXQRSPYYB4')
		return
	       }

	 this.dialogService.open(PaymentDonateModalComponent, {
			       
			      context: { 
				stream: this.stream
			      },
				
			     closeOnEsc: false,
				closeOnBackdropClick: false
			    });

  }

  ngOnDestroy() {
    if(this.player){
   	 this.player.destroy()

	}  
  
  

	if(this.statTimer){clearInterval(this.statTimer); this.statTimer  = null; }
	this.statUpdate() 

	//if(this.watchTime$){ this.watchTime$.unsubscribe()}

	this.socket.removeAllListeners('donateStateChanged');
	this.socket.removeAllListeners('changeWatchers');
	this.socket.removeAllListeners('showWatchersToggle');


  }
}


